<template>
  <b-container>
    <b-row>
      <b-col sm="4" class="text-left">
        <h1>Hírszerkesztő</h1>
      </b-col>
      <b-col sm="4">
        <b-form-group label-for="filter-input">
          <!--<b-form-input
            @update="onFilterChange('name', $event)"
            id="filter-name-input"
            :value="competitionNameFilter"
            type="search"
            placeholder="Keresés"
            class="search-box"
          ></b-form-input>-->
        </b-form-group>
      </b-col>
      <b-col sm="2" class="text-left mt-2 pl-0">
        <b-link v-b-modal.filter-modal class="filter-link" v-if="false">Szűrők</b-link>
        <b-modal id="filter-modal" title="Szűrők" size="xl" hide-header hide-footer>
          <!--<competition-list-filter
            :filters="competitionFilters"
            :onFilter="onFilter"
            :closeModal="() => $bvModal.hide('filter-modal')"
          />-->
        </b-modal>
      </b-col>
      <b-col sm="2" class="pr-0">
        <b-button class="competition-button" @click="navigateToCreate()" variant="primary">Új hír</b-button>
      </b-col>
    </b-row>
    <!--<div class="d-flex flex-row flex-wrap text-left justify-content-between mt-3 mb-5">
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.SHOW_ALL) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.SHOW_ALL)"
      >
        Összes
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.IN_PROGRESS) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.IN_PROGRESS)"
      >
        Piszkozat
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.UNDER_APPROVAL) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.UNDER_APPROVAL)"
      >
        Jóváhagyás alatt
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.APPROVED) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.APPROVED)"
      >
        Jóváhagyott
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.ACTIVE) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.ACTIVE)"
      >
        Aktív
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.INACTIVE) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.INACTIVE)"
      >
        Lejárt
      </div>
    </div>-->

    <!-- Main table element -->
    <b-table
      :sort-compare="mySortCompare"
      :items="newsList"
      :fields="fields"
      :current-page="0"
      per-page="0"
      :filter-included-fields="['name', 'createdDate', 'modifiedDate']"
      class="mt-3"
    >
      <template #cell(name)="data"
        ><b-link :to="{ path: '/contents/news/edit', query: { id: data.item._id } }">{{ data.item.name }}</b-link>
      </template>
      <template #cell(editAction)="row">
        <b-button size="sm" variant="warning" @click="editNews(row.item)" class="mr-1 action-button">
          Módosítás
        </b-button>
      </template>
      <template #cell(deleteAction)="row">
        <b-button size="sm" variant="danger" @click="deleteNews(row.item)" class="mr-1 action-button">
          Törlés
        </b-button>
      </template>
      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import { getNewsList, deleteNews } from '../../api/news'

export default {
  name: 'ListNews',
  data() {
    return {
      newsList: [],
      fields: [
        {
          key: 'name',
          label: 'Hír címe'
        },
        {
          key: 'createdBy.fullName',
          label: 'Létrehozta'
        },
        {
          key: 'createdDate',
          label: 'Létrehozva',
          formatter: date => this.formatDate(date)
        },
        {
          key: 'modifiedDate',
          label: 'Utolsó módosítás',
          formatter: date => this.formatDate(date)
        },
        { key: 'editAction', label: 'Módosítás' },
        { key: 'deleteAction', label: 'Törlés' }
      ]
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async refreshNews() {
      this.newsList = []
      this.newsList = await getNewsList()
    },
    // eslint-disable-next-line no-unused-vars
    async deleteNews(item) {
      try {
        await deleteNews(item.id)
        await this.refreshNews()
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'success',
            message: 'Hír törlése sikeres. '
          }
        })
      } catch (e) {
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'error',
            message: 'Hiba történt a hír törlése közben: ' + e
          }
        })
        console.log(e)
      }
    },
    async editNews(item) {
      this.$router.push(`/contents/news/edit?id=${item.id}`)
    },
    mySortCompare(a, b, key) {
      if (key === 'createdDate' || key === 'modifiedDate') {
        return new Date(a[key]) - new Date(b[key])
      } else {
        return false
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    navigateToCreate: function() {
      this.$router.push('/contents/news/create')
    }
  },
  async mounted() {
    await this.refreshNews()
  }
}
</script>

<style>
.action-button {
  width: 85px;
}
</style>
